import { render, staticRenderFns } from "./WidgetView.vue?vue&type=template&id=0acd5219&scoped=true"
import script from "./WidgetView.vue?vue&type=script&lang=js"
export * from "./WidgetView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acd5219",
  null
  
)

export default component.exports